import { all } from "redux-saga/effects";

import * as management from "./management/";

export function* rootSaga() {
  yield all([management.rootSaga()]);
}
